// QR Nation custom.js (safe + unified)

document.addEventListener("DOMContentLoaded", () => {
  /* -------------------------------
    Accordion (SAFE)
  -------------------------------- */
  const accordions = document.querySelectorAll(".qr-accordion");
  if (accordions.length) {
    accordions.forEach((details) => {
      details.removeAttribute("open"); // start closed
      const summary = details.querySelector("summary");
      if (!summary) return;

      summary.addEventListener("click", (e) => {
        e.preventDefault();

        const wasOpen = details.hasAttribute("open");
        accordions.forEach((d) => d.removeAttribute("open"));
        if (!wasOpen) details.setAttribute("open", "true");
      });
    });
  }

  /* -------------------------------
    Shape/image selection (SAFE)
  -------------------------------- */
  function setupSelection(groupId, inputId) {
    const group = document.getElementById(groupId);
    const input = document.getElementById(inputId);
    if (!group || !input) return;

    group.addEventListener("click", (e) => {
      const img = e.target.closest("img");
      if (!img || !group.contains(img)) return;

      group.querySelectorAll("img.selected").forEach((i) => i.classList.remove("selected"));
      img.classList.add("selected");

      input.value = img.getAttribute("data-value") || "";
    });
  }

  setupSelection("qr_logos", "qr_logo");
  setupSelection("body_shapes", "qr_body");
  setupSelection("eye_frame_shapes", "qr_eye_frame");
  setupSelection("eye_ball_shapes", "qr_eye_ball");

  /* -------------------------------
    Shared elements (URL/File/Form)
  -------------------------------- */
  const form =
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  const urlInput = document.getElementById("qr_url");
  const fileInput = document.getElementById("file_upload");
  const removeFileBtn = document.getElementById("remove_file_button");
  const fileNameDisplay = document.getElementById("file_name_display");
  const buyNowBtn = document.getElementById("buy_it_now_button");

  const textInput = document.getElementById("qr_text");
const previewBox = document.getElementById("preview-box");
const charCount = document.getElementById("char-count");
const fontSelect = document.getElementById("font-select");
const overlay = document.getElementById("qr-text-overlay");

  const urlWarning = document.getElementById("qr-url-warning");
  const fileWarning = document.getElementById("file-upload-warning");

  const bodyInput = document.getElementById("qr_body");
  const frameInput = document.getElementById("qr_eye_frame");
  const ballInput = document.getElementById("qr_eye_ball");

  /* -------------------------------
    URL/File mutual exclusion UI (SAFE)
  -------------------------------- */
  function updateUploadUI() {
    const hasUrl = !!(urlInput && urlInput.value.trim() !== "");
    const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

    // warnings
    if (urlWarning) urlWarning.style.display = hasFile ? "block" : "none";
    if (fileWarning) fileWarning.style.display = hasUrl ? "block" : "none";

    // disable / enable
    if (fileInput) fileInput.disabled = hasUrl;
    if (urlInput) urlInput.disabled = hasFile;

    // remove button + file name
    if (removeFileBtn) removeFileBtn.style.display = hasFile ? "inline-block" : "none";
    if (fileNameDisplay) fileNameDisplay.textContent = hasFile ? fileInput.files[0].name : "No file selected";
  }

  /* -------------------------------
    File validation (SAFE)
  -------------------------------- */
  function validateFile() {
    if (!fileInput || !fileInput.files || !fileInput.files[0]) return true;

    const maxSizeMB = 50;
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "audio/mpeg",
      "video/mp4",
      "video/quicktime"
    ];

    const file = fileInput.files[0];
    const sizeMB = file.size / (1024 * 1024);

    if (sizeMB > maxSizeMB) {
      alert(`File is too large. Max size is ${maxSizeMB} MB.`);
      fileInput.value = "";
      updateUploadUI();
      return false;
    }

    if (!allowedTypes.includes(file.type)) {
      alert("Invalid file type. Accepted formats: .pdf, .jpg, .png, .mp3, .mp4, .mov");
      fileInput.value = "";
      updateUploadUI();
      return false;
    }

    return true;
  }

  if (fileInput) {
    fileInput.addEventListener("change", () => {
      validateFile();
      updateUploadUI();
    });
  }
  if (urlInput) urlInput.addEventListener("input", updateUploadUI);
  if (removeFileBtn && fileInput) {
    removeFileBtn.addEventListener("click", () => {
      fileInput.value = "";
      updateUploadUI();
    });
  }

  /* -------------------------------
    Form validation (URL OR file + shapes)
  -------------------------------- */
  function validateBeforeSubmit() {
    let ok = true;

    const hasUrl = !!(urlInput && urlInput.value.trim() !== "");
    const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

    // If both exist: require at least one
    if (urlInput && fileInput) {
      if (!hasUrl && !hasFile) {
        if (urlWarning) urlWarning.style.display = "block";
        if (fileWarning) fileWarning.style.display = "block";
        (urlInput || fileInput).scrollIntoView({ behavior: "smooth", block: "center" });
        ok = false;
      } else {
        if (urlWarning) urlWarning.style.display = "none";
        if (fileWarning) fileWarning.style.display = "none";
      }
    } else if (urlInput && urlWarning) {
      // If only URL exists on that template: require it
      if (!hasUrl) {
        urlWarning.style.display = "block";
        urlInput.scrollIntoView({ behavior: "smooth", block: "center" });
        ok = false;
      } else {
        urlWarning.style.display = "none";
      }
    }

    // Shapes required only if those inputs exist
    const bodyOk = !bodyInput || !!bodyInput.value;
    const frameOk = !frameInput || !!frameInput.value;
    const ballOk = !ballInput || !!ballInput.value;

    if (!(bodyOk && frameOk && ballOk)) {
      alert("Please select Body Shape, Eye Frame Shape, and Eye Ball Shape before continuing.");
      ok = false;
    }

    // File type/size validation
    if (fileInput && hasFile) {
      if (!validateFile()) ok = false;
    }

    return ok;
  }

  /* -------------------------------
    Buy Now + fee product logic (SAFE)
  -------------------------------- */
  const FEE_VARIANT_ID = 55196148466050;
  let buyNowClicked = false;

  if (buyNowBtn && form) {
    buyNowBtn.addEventListener("click", () => {
      buyNowClicked = true;
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
    });
  }

  if (form) {
    form.addEventListener("submit", (e) => {
      if (!validateBeforeSubmit()) {
        e.preventDefault();
        buyNowClicked = false;
        return;
      }

      const hasFile = !!(fileInput && fileInput.files && fileInput.files.length > 0);

      // If file present: add fee first, then main product
      if (hasFile) {
        e.preventDefault();

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: FEE_VARIANT_ID, quantity: 1 })
        })
          .then((res) => {
            if (!res.ok) throw new Error("Fee product failed");
            return res.json();
          })
          .then(() => {
            const formData = new FormData(form);
            return fetch("/cart/add.js", { method: "POST", body: formData });
          })
          .then((res) => {
            if (!res.ok) throw new Error("Main product failed");
            return res.json();
          })
          .then(() => {
            window.location.href = buyNowClicked ? "/checkout" : "/cart";
          })
          .catch((err) => {
            console.error(err);
            alert("Something went wrong. Please try again.");
          })
          .finally(() => {
            buyNowClicked = false;
          });

        return;
      }

      // If no file, but Buy Now clicked: force checkout redirect after add
      if (buyNowClicked) {
        e.preventDefault();

        const formData = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: formData })
          .then((res) => {
            if (!res.ok) throw new Error("Main product failed");
            return res.json();
          })
          .then(() => {
            window.location.href = "/checkout";
          })
          .catch((err) => {
            console.error(err);
            alert("Could not complete order.");
          })
          .finally(() => {
            buyNowClicked = false;
          });
      }
    });
  }

  // init upload UI once
  updateUploadUI();

    /* -------------------------------
    Move text preview into media container (STABLE)
  -------------------------------- */
  const mediaContainer = document.querySelector(
    "#MainProduct-template--27598228029782__main > div > div > div.grid__item.product__media-wrapper > div"
  );
  const textPreview = document.querySelector(".custom-text-preview");

  if (mediaContainer && textPreview && !mediaContainer.contains(textPreview)) {
    mediaContainer.appendChild(textPreview);
  }




  if (textInput && previewBox) {
    const syncText = () => {
      const raw = textInput.value || "";
      const trimmed = raw.trim();
      const txt = trimmed ? trimmed : "Ton texte apparaîtra ici...";

      if (charCount) charCount.textContent = `${raw.length} / 50 caractères`;
      previewBox.textContent = txt;
      if (overlay) overlay.textContent = txt;
    };

    textInput.addEventListener("input", syncText);

    if (fontSelect) {
      previewBox.style.fontFamily = fontSelect.value || previewBox.style.fontFamily;
      if (overlay) overlay.style.fontFamily = fontSelect.value || "";

      fontSelect.addEventListener("change", () => {
        previewBox.style.transition = "all 0.25s ease";
        previewBox.style.fontFamily = fontSelect.value;

        if (overlay) {
          overlay.style.transition = "all 0.25s ease";
          overlay.style.fontFamily = fontSelect.value;
        }
      });
    }

    syncText();

    function getSelectedColorValue() {
      const sel = document.querySelector('select[name="options[Couleur]"]');
      if (sel && sel.value) return sel.value;

      const radio = document.querySelector('input[name="options[Couleur]"]:checked');
      if (radio && radio.value) return radio.value;

      return "";
    }

    function updateTextColorByShirt() {
      const val = (getSelectedColorValue() || "").toLowerCase();
      const dark = ["noir", "black", "navy", "marine", "charcoal", "anthracite", "dark"];
      const isDark = dark.some((w) => val.includes(w));
      const color = isDark ? "#ffffff" : "#000000";

      const span = document.querySelector(".custom-text-preview span");
      if (span) {
        span.style.color = color;
        span.style.background = "transparent";
      }
    }

    updateTextColorByShirt();

    document.addEventListener("change", (e) => {
      if (
        e.target &&
        (e.target.matches('select[name="options[Couleur]"]') ||
          e.target.matches('input[name="options[Couleur]"]'))
      ) {
        updateTextColorByShirt();
      }
    });
  }



  /* -------------------------------
    Color picker (SAFE)
  -------------------------------- */
  const colorPreview = document.querySelector(".color-preview");
  const hueSlider = document.getElementById("slider-hue");
  const saturationSlider = document.getElementById("slider-saturation");
  const lightnessSlider = document.getElementById("slider-lightness");
  const hueValue = document.getElementById("current-hue-value");
  const saturationValue = document.getElementById("current-saturation-value");
  const lightnessValue = document.getElementById("current-lightness-value");
  const qrColorInput = document.getElementById("qr_color");
  const colorCodeDisplay = document.getElementById("color-code-display");
  const hexInput = document.getElementById("manual-hex-input");
  const clearBtn = document.getElementById("clear-color");

  const hasColorUI =
    colorPreview || hueSlider || saturationSlider || lightnessSlider || qrColorInput || hexInput;

  if (hasColorUI) {
    let hue = 180;
    let saturation = 50;
    let lightness = 50;

    function hslToHex(h, s, l) {
      s /= 100;
      l /= 100;

      const c = (1 - Math.abs(2 * l - 1)) * s;
      const x = c * (1 - Math.abs((h / 60) % 2 - 1));
      const m = l - c / 2;

      let r = 0, g = 0, b = 0;

      if (0 <= h && h < 60) [r, g, b] = [c, x, 0];
      else if (60 <= h && h < 120) [r, g, b] = [x, c, 0];
      else if (120 <= h && h < 180) [r, g, b] = [0, c, x];
      else if (180 <= h && h < 240) [r, g, b] = [0, x, c];
      else if (240 <= h && h < 300) [r, g, b] = [x, 0, c];
      else [r, g, b] = [c, 0, x];

      r = Math.round((r + m) * 255).toString(16).padStart(2, "0");
      g = Math.round((g + m) * 255).toString(16).padStart(2, "0");
      b = Math.round((b + m) * 255).toString(16).padStart(2, "0");

      return `#${r}${g}${b}`;
    }

    function hexToHsl(hex) {
      hex = (hex || "").replace(/^#/, "");
      if (hex.length === 3) hex = hex.split("").map((h) => h + h).join("");

      const r = parseInt(hex.substring(0, 2), 16) / 255;
      const g = parseInt(hex.substring(2, 4), 16) / 255;
      const b = parseInt(hex.substring(4, 6), 16) / 255;

      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      let h = 0, s = 0;
      const l = (max + min) / 2;

      if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r: h = (g - b) / d + (g < b ? 6 : 0); break;
          case g: h = (b - r) / d + 2; break;
          case b: h = (r - g) / d + 4; break;
        }
        h *= 60;
      }

      return { h: Math.round(h), s: Math.round(s * 100), l: Math.round(l * 100) };
    }

    function updateSaturationSliderBackground(h) {
      if (!saturationSlider) return;
      saturationSlider.style.background =
        `linear-gradient(to right, hsl(${h}, 0%, 50%), hsl(${h}, 100%, 50%))`;
    }

    function updateColorPreview() {
      const hsl = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      const hex = hslToHex(hue, saturation, lightness);

      if (colorPreview) colorPreview.style.background = hsl;
      if (qrColorInput) qrColorInput.value = hex;
      if (colorCodeDisplay) colorCodeDisplay.textContent = hex;

      updateSaturationSliderBackground(hue);
    }

    // Init defaults
    if (hueSlider) hueSlider.value = hue;
    if (saturationSlider) saturationSlider.value = saturation;
    if (lightnessSlider) lightnessSlider.value = lightness;

    if (hueValue) hueValue.textContent = hue;
    if (saturationValue) saturationValue.textContent = saturation;
    if (lightnessValue) lightnessValue.textContent = lightness;

    if (hexInput && !hexInput.value) hexInput.value = "#40bfbf";

    if (hueSlider) {
      hueSlider.addEventListener("input", () => {
        hue = Number(hueSlider.value);
        if (hueValue) hueValue.textContent = hue;
        updateColorPreview();
      });
    }

    if (saturationSlider) {
      saturationSlider.addEventListener("input", () => {
        saturation = Number(saturationSlider.value);
        if (saturationValue) saturationValue.textContent = saturation;
        updateColorPreview();
      });
    }

    if (lightnessSlider) {
      lightnessSlider.addEventListener("input", () => {
        lightness = Number(lightnessSlider.value);
        if (lightnessValue) lightnessValue.textContent = lightness;
        updateColorPreview();
      });
    }

    if (hexInput) {
      hexInput.addEventListener("input", () => {
        const hex = hexInput.value.trim();
        if (!/^#([0-9A-F]{3}){1,2}$/i.test(hex)) return;

        const hsl = hexToHsl(hex);
        hue = hsl.h;
        saturation = hsl.s;
        lightness = hsl.l;

        if (hueSlider) hueSlider.value = hue;
        if (saturationSlider) saturationSlider.value = saturation;
        if (lightnessSlider) lightnessSlider.value = lightness;

        if (hueValue) hueValue.textContent = hue;
        if (saturationValue) saturationValue.textContent = saturation;
        if (lightnessValue) lightnessValue.textContent = lightness;

        updateColorPreview();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener("click", () => {
        hue = 0;
        saturation = 0;
        lightness = 0;

        if (hueSlider) hueSlider.value = hue;
        if (saturationSlider) saturationSlider.value = saturation;
        if (lightnessSlider) lightnessSlider.value = lightness;

        if (hexInput) hexInput.value = "";
        if (hueValue) hueValue.textContent = hue;
        if (saturationValue) saturationValue.textContent = saturation;
        if (lightnessValue) lightnessValue.textContent = lightness;

        updateColorPreview();
      });
    }

    updateColorPreview();
  }
});



/* ===============================
   iPhone model → body class (robuste)
   Ciblé sur: /products/coque-de-telephone-apple-love-yourself-first
   =============================== */
(function () {
  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getSelectedIphoneModelText() {
    // Radios
    const checkedRadios = Array.from(document.querySelectorAll('input[type="radio"]:checked'));
    for (const r of checkedRadios) {
      const v = (r.value || "").trim();
      if (/iphone/i.test(v)) return v;
    }

    // Selects
    const selectedOptions = Array.from(document.querySelectorAll("select option:checked"));
    for (const o of selectedOptions) {
      const v = (o.textContent || "").trim();
      if (/iphone/i.test(v)) return v;
    }

    return "";
  }

  function updateIphoneBodyClass() {
    const productInfo = document.querySelector("product-info");
    if (!productInfo) return;

    const url = productInfo.getAttribute("data-url") || "";
    // Pour l'instant: uniquement ce produit
    if (!/coque-de-telephone-(apple|iphone)-love-yourself-first/.test(url)) return;

    const modelText = getSelectedIphoneModelText();
    if (!modelText) return;

    // Nettoie les anciennes classes iphone-*
    document.body.className = document.body.className
      .split(/\s+/)
      .filter((c) => c && !c.startsWith("iphone-"))
      .join(" ")
      .trim();

    document.body.classList.add("iphone-" + slugify(modelText));
  }

  document.addEventListener("DOMContentLoaded", updateIphoneBodyClass);
  document.addEventListener("change", updateIphoneBodyClass);
  document.addEventListener("variant:change", updateIphoneBodyClass);
})();

/* ===== FIX IMAGES COQUE MOBILE ===== */
(function fixCoqueImagesMobile() {
  if (!document.querySelector('[data-section]')) return;
  
  // Détecte si c'est une coque
  var isCoqueProduct = document.querySelector('[data-media-id*="extra1"]') !== null;
  if (!isCoqueProduct) return;

  function waitForImages(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 20) return;
    
    // Cherche les deux imgs extra dans TOUS les slides possibles
    // Sur mobile, Dawn utilise un slider avec des data-media-id différents
    var allMediaItems = document.querySelectorAll('.product__media-item img');
    
    // Si moins de 2 images trouvées, on réessaie
    if (allMediaItems.length < 2) {
      setTimeout(function() { waitForImages(callback, attempts + 1); }, 200);
      return;
    }
    callback(allMediaItems);
  }

  function forceUpdateAllImages() {
    return; // DÉSACTIVÉ: le snippet Liquid rend deja mockup+perso (marque+couleur via handle), ce JS ecrasait avec iphone/violet
    // Récupère la couleur actuelle
    var color = null;
    var selects = document.querySelectorAll('select[name^="options["]');
    selects.forEach(function(s) {
      var lbl = s.closest && s.closest('.product-form__input') && 
                s.closest('.product-form__input').querySelector('label');
      if (lbl && lbl.textContent.toLowerCase().indexOf('couleur') !== -1) {
        color = s.value;
      }
    });
    
    // Boutons radio
    if (!color) {
      var checked = document.querySelector('.product-form__input input[type="radio"]:checked');
      if (checked) {
        var lbl = checked.closest && checked.closest('.product-form__input') &&
                  checked.closest('.product-form__input').querySelector('.form__label');
        if (lbl && lbl.textContent.toLowerCase().indexOf('couleur') !== -1) {
          color = checked.value;
        }
      }
    }
    
    if (!color) color = 'violet'; // fallback par défaut coque

    // Déclenche updateImages si elle existe dans la page
    if (typeof window.updateImages === 'function') {
      window.updateImages(color);
      return;
    }
    
    // Sinon on cherche le script custom.js et on reconstruis les URLs manuellement
    var base = null;
    var designs_mockup = null;
    var designs_perso = null;
    var couleurs_mockup = null;
    
    // Extrait les variables du script inline
    document.querySelectorAll('script').forEach(function(s) {
      if (s.textContent.indexOf('designs_mockup') !== -1 && !base) {
        var baseMatch = s.textContent.match(/var base = '([^']+)'/);
        if (baseMatch) base = baseMatch[1];
        
        try {
          var dmMatch = s.textContent.match(/var designs_mockup = \{([^}]+)\}/s);
          var dpMatch = s.textContent.match(/var designs_perso = \{([^}]+)\}/s);
          var cmMatch = s.textContent.match(/var couleurs_mockup = \{([^}]+)\}/);
          // Parse simplifié des objets
          if (dmMatch) {
            eval('designs_mockup = {' + dmMatch[1] + '}');
          }
          if (dpMatch) {
            eval('designs_perso = {' + dpMatch[1] + '}');
          }
          if (cmMatch) {
            eval('couleurs_mockup = {' + cmMatch[1] + '}');
          }
        } catch(e) {}
      }
    });
    
    if (!base || !designs_mockup || !designs_perso || !couleurs_mockup) return;
    
    var title = document.querySelector('.product__title h1');
    if (!title) return;
    var titleText = title.textContent.trim();
    
    var design_mockup = '', design_perso = '';
    for (var key in designs_mockup) {
      if (titleText.indexOf(key) !== -1) {
        design_mockup = designs_mockup[key];
        design_perso = designs_perso[key];
        break;
      }
    }
    
    if (!design_mockup) return;
    
    var c = color.toLowerCase();
    var couleur = couleurs_mockup[c] || color;
    
    var mockupSrc = base + 'iphone-_-' + design_mockup + '_-_' + couleur + '.jpg';
    var persoSrc  = base + 'iphone-_-' + design_perso  + '_-_perso_-_' + c + '.jpg';
    
    // Force la mise à jour sur TOUS les éléments media (mobile ET desktop)
    // Cherche par data-media-id ou par position
    var allItems = document.querySelectorAll('.product__media-item');
    
    allItems.forEach(function(item, index) {
      var img = item.querySelector('img');
      if (!img) return;
      
      var mediaId = item.dataset.mediaId || '';
      var isExtra1 = mediaId.indexOf('extra1') !== -1 || 
                     item.id.indexOf('extra1') !== -1 ||
                     (img.src && img.src === '');
      var isExtra2 = mediaId.indexOf('extra2') !== -1 || 
                     item.id.indexOf('extra2') !== -1;
      
      if (isExtra1) {
        img.src = mockupSrc;
        if (img.dataset) img.dataset.src = mockupSrc;
        img.removeAttribute('data-srcset');
        img.setAttribute('srcset', mockupSrc);
      } else if (isExtra2) {
        img.src = persoSrc;
        if (img.dataset) img.dataset.src = persoSrc;
        img.removeAttribute('data-srcset');
        img.setAttribute('srcset', persoSrc);
      }
    });
    
    // Cas mobile : les slides extra peuvent avoir src vide
    // On force aussi via les sélecteurs Dawn génériques
    var extra1 = document.querySelector('[data-media-id*="extra1"] img, .product__media-item:nth-child(2) img');
    var extra2 = document.querySelector('[data-media-id*="extra2"] img, .product__media-item:nth-child(3) img');
    
    if (extra1 && (!extra1.src || extra1.src === window.location.href || extra1.src.endsWith('/'))) {
      extra1.src = mockupSrc;
      extra1.setAttribute('srcset', mockupSrc);
    }
    if (extra2 && (!extra2.src || extra2.src === window.location.href || extra2.src.endsWith('/'))) {
      extra2.src = persoSrc;
      extra2.setAttribute('srcset', persoSrc);
    }
  }

  // Lance au chargement avec plusieurs tentatives espacées
  var delays = [300, 600, 1000, 1500, 2500];
  delays.forEach(function(delay) {
    setTimeout(forceUpdateAllImages, delay);
  });
  
  // Relance aussi au changement de couleur
  document.addEventListener('change', function(e) {
    if (e.target.matches('select[name^="options["]') || 
        e.target.matches('input[type="radio"]')) {
      setTimeout(forceUpdateAllImages, 150);
    }
  });
  
  // Observe le slider mobile de Dawn (il peut charger lazy les slides)
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector && node.querySelector('img[src=""]')) {
          setTimeout(forceUpdateAllImages, 100);
        }
      });
    });
  });
  
  var mediaWrapper = document.querySelector('.product__media-wrapper');
  if (mediaWrapper) {
    observer.observe(mediaWrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
// Expose updateImages globalement pour main-product.liquid
  window.updateImages = function(colorRaw) {
    return; // DÉSACTIVÉ: rendu serveur via snippet Liquid
    var base = 'https://cdn.shopify.com/s/files/1/0952/7836/7062/files/';
    var couleurs_mockup = { 'violet': 'Violet', 'rose': 'Rose', 'noir': 'noir', 'blanc': 'blanc' };

    var c = colorRaw.toLowerCase();
    var couleur = couleurs_mockup[c] || colorRaw;

    var titleEl = document.querySelector('.product__title h1');
    if (!titleEl) return;
    var titleText = titleEl.textContent.trim();

    var designs_mockup = {
      'Main Character Energy': 'Main_Character_Energy',
      "I'm Just a Girl": 'Im_Just_A_Girl',
      'In My It Girl Era': 'In_My_It_Girl_Era',
      'Shock Everyone': 'Shock_Everyone',
      'I Am The Best Version': 'I_Am_The_Best_Version_Of_Myself',
      'Love Yourself First': 'Love_Yourself_First',
      'Self Care': 'Self_Care',
      'Now Or Never': 'Now_Or_Never_Girl',
      'Be a Good Person': 'Be_A_Good_Person'
    };
    var designs_perso = {
      'Main Character Energy': 'main_character_energy',
      "I'm Just a Girl": 'im_just_a_girl',
      'In My It Girl Era': 'in_my_it_girl_era',
      'Shock Everyone': 'shock_everyone',
      'I Am The Best Version': 'i_am_the_best_version_of_myself',
      'Love Yourself First': 'love_yourself_first',
      'Self Care': 'self_care',
      'Now Or Never': 'now_or_never_girl',
      'Be a Good Person': 'be_a_good_person'
    };

    var design_mockup = '', design_perso = '';
    for (var key in designs_mockup) {
      if (titleText.indexOf(key) !== -1) {
        design_mockup = designs_mockup[key];
        design_perso  = designs_perso[key];
        break;
      }
    }
    if (!design_mockup) return;

    var mockupSrc = base + 'iphone_-_' + design_mockup + '_-_' + couleur + '.jpg';
    var persoSrc  = base + 'iphone_-_' + design_perso  + '_-_perso_-_' + c + '.jpg';

    var imgMockup = document.querySelector('[data-media-id*="extra1"] img') ||
                    document.querySelector('.product__media-item:nth-child(2) img');
    var imgPerso  = document.querySelector('[data-media-id*="extra2"] img') ||
                    document.querySelector('.product__media-item:nth-child(3) img');

    function setImg(img, src) {
      if (!img) return;
      img.src = src;
      img.setAttribute('srcset', src);
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.style.visibility = 'visible';
      img.style.opacity = '1';
    }

    setImg(imgMockup, mockupSrc);
    setImg(imgPerso, persoSrc);
  };
  var applyExtraWidth = function() {
    var e1 = document.querySelector('[data-media-id*="extra1"]');
    var e2 = document.querySelector('[data-media-id*="extra2"]');
    var w = window.innerWidth < 750 ? '100%' : 'calc(50% - 1rem)';
    [e1, e2].forEach(function(el) {
      if (el) el.style.cssText += ';width:' + w + '!important;min-width:0!important;flex-shrink:0!important;';
    });
  };
  setTimeout(applyExtraWidth, 500);
  window.addEventListener('resize', applyExtraWidth);
})();